import React from "react";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { filter, get, map, includes } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmarkCircle } from "@fortawesome/pro-solid-svg-icons";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FileData } from "../../../../@types/files";

import ProgressCircle from "components/shared/ProgressCircle";

export default function ImageAttachments({
  images,
  chatId,
}: {
  images: (File & FileData)[];
  chatId: string;
}) {
  const dispatch = useDispatch();

  function remove({ id }: { id: string }) {
    dispatch({
      type: "chat/COMPOSER/SET_IMAGE_ATTACHMENTS",
      chatId,
      fileAttachments: filter(images, (image) => get(image, "id") !== id),
    });
  }

  return (
    <div className="relative bg-white gap-2 px-2 py-2 rounded">
      <div className="flex gap-2 overflow-x-auto">
        {map(images, (image, index) => (
          <div className="stack-container shrink-0" key={index}>
            {image.state === "uploading" &&
            image.progress &&
            image.progress <= 100 ? (
              <div className="flex items-center justify-center w-16 h-16 bg-gray-50 animate-pulse rounded">
                <ProgressCircle progress={image.progress} />
              </div>
            ) : includes(["failed", "quarantine"], image.state) ? (
              <div className="stack-item flex items-center justify-center w-16 h-16 bg-danger/25 rounded">
                <FontAwesomeIcon
                  className="text-danger"
                  icon={faTriangleExclamation}
                  size="2xl"
                />
              </div>
            ) : (
              image.state === "volatile" && (
                <img
                  className={classNames(
                    "w-16 h-16 object-cover rounded stack-item",
                  )}
                  src={`/api/storage/images/${image.id}/get/200x200`}
                />
              )
            )}
            {image.state !== "uploading" && (
              <div className="stack-item flex justify-end items-start shrink-0 px-1">
                <button
                  className="max-w-max max-h-max"
                  onClick={() => image.id && remove({ id: image.id })}
                >
                  <FontAwesomeIcon
                    className="text-muted"
                    icon={faXmarkCircle}
                    size="1x"
                  />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
